module.exports = "<div class=\"toolbar-button\" fxLayout=\"row\" fxLayoutAlign=\"center stretch\" style=\"height: 100%;\">\n  <mat-form-field class=\"search\" [class.search-open]=\"isOpen\">\n    <input #input (blur)=\"close()\" matInput i18n-placeholder=\"@@Search\" placeholder=\"Search...\">\n  </mat-form-field>\n  <button class=\"icon-button\" mat-button (click)=\"open()\">\n    <mat-icon>search</mat-icon>\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/toolbar/search/search.component.html
// module id = ../../../../../src/app/core/toolbar/search/search.component.html
// module chunks = main